import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { isNumber } from './assertion.esm.js';
import { filterObject } from './object.esm.js';
import classnames from 'classnames';

/**
 * Get classnames from props values in a whitelisted set of keys
 */

function mapClassNames(props, keys) {
  return keys == null ? void 0 : keys.map(function (k) {
    return props[k];
  }).filter(Boolean).flat();
}
/**
 * Map props and classnames
 * @param props
 * @param rest
 * @param keys
 */

function mapProps(props, rest, keys, classNames) {
  if (classNames === void 0) {
    classNames = [];
  }

  var className = classnames.apply(void 0, classNames.concat(mapClassNames(props, keys))) || undefined;
  return _extends({
    className: className
  }, filterObject(rest, keys, true));
}
function mapTruncateValue(truncate) {
  if (truncate === true) {
    return 'truncate';
  }

  if (isNumber(truncate)) {
    switch (truncate) {
      case 2:
        return 'truncate-2-lines';

      case 3:
        return 'truncate-3-lines';

      case 4:
        return 'truncate-4-lines';

      case 5:
        return 'truncate-5-lines';

      default:
        return undefined;
    }
  }

  return undefined;
}

export { mapClassNames, mapProps, mapTruncateValue };
//# sourceMappingURL=style-props.esm.js.map
